"use client";
import React from "react";
import { motion } from "framer-motion";
const BlogTitleSection = () => {
  return (
    <section className="flex flex-col items-center w-full max-w-6xl mx-auto gap-6 sm:gap-8 px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20 bg-[#FFFFFFE6]">
      <motion.h1
        className="text-[#FFAE00] font-bricolage font-bold text-center tracking-tight leading-tight
               text-2xl sm:text-4xl md:text-5xl lg:text-6xl max-w-4xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        Travel That Leaves a Mark — Not Just on the Map, But on You.
      </motion.h1>

      <motion.p
        className="text-[#063258]  font-bricolage text-center leading-relaxed 
               text-base sm:text-lg md:text-xl max-w-3xl px-2 sm:px-4"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      >
        At Outcome Outing, we don’t just fulfill travel dreams — we design
        journeys that bring transformation, clarity, and lifelong connections.
        Every trip is a shared chapter, every destination a stage for
        self-growth. Join a tribe that travels with intent, led by mentors who
        inspire, and communities that stay with you long after the trip ends.
      </motion.p>
    </section>
  );
};

export default BlogTitleSection;
